// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.super-admin-management {
  padding: 20px;
}

.super-admin-management h2 {
  color: #65ccb7;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.8em;
}

.section-icon {
  font-size: 1.4em;
}

.modal-icon {
  font-size: 1.2em;
  margin-right: 8px;
}

.super-admin-status-approved {
  background-color: #65ccb7;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 0.9em;
  display: flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  font-weight: 500;
}

.super-admin-edit-btn,
.super-admin-edit-credentials-btn,
.super-admin-delete-btn {
  padding: 8px 16px;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

.super-admin-edit-btn {
  background-color: #65ccb7;
}

.super-admin-edit-credentials-btn {
  background-color: #4a90e2;
}

.super-admin-delete-btn {
  background-color: #e74c3c;
}

.super-admin-edit-btn:hover,
.super-admin-edit-credentials-btn:hover,
.super-admin-delete-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.super-admin-edit-btn:hover {
  background-color: #55bb9f;
}

.super-admin-edit-credentials-btn:hover {
  background-color: #357abd;
}

.super-admin-delete-btn:hover {
  background-color: #c0392b;
}

.super-admin-permissions {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.super-admin-permissions-modal {
  margin-top: 20px;
  padding: 24px;
  background: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.super-admin-permissions-modal h3 {
  color: #333;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  font-size: 1.4em;
}

.super-admin-permissions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
  margin-top: 15px;
}

.super-admin-permission-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #eee;
}

.super-admin-permission-item:hover {
  background: #f5f5f5;
  transform: translateY(-1px);
}

.super-admin-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 30px;
  list-style: none;
  padding: 0;
}

.super-admin-pagination-link {
  padding: 10px 16px;
  border: 1px solid #65ccb7;
  border-radius: 6px;
  cursor: pointer;
  color: #65ccb7;
  transition: all 0.3s ease;
  font-weight: 500;
}

.super-admin-pagination-link:hover {
  background-color: #f5f5f5;
}

.super-admin-pagination-active {
  background-color: #65ccb7;
  color: white;
}

.super-admin-pagination-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.super-admin-actions {
  display: flex;
  gap: 8px;
}

.super-admin-edit-input {
  width: 100%;
  padding: 8px 12px;
  border: 2px solid #eee;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.super-admin-edit-input:focus {
  outline: none;
  border-color: #65ccb7;
  box-shadow: 0 0 0 3px rgba(101, 204, 183, 0.1);
}

.super-admin-table-container {
  overflow-x: auto;
  height: 54vh;
  overflow-y: scroll;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.super-admin-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0;
}

.super-admin-table th,
.super-admin-table td {
  padding: 16px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.super-admin-table th {
  background-color: #f8f9fa;
  color: #333;
  font-weight: 600;
  white-space: nowrap;
}

.super-admin-table tr:hover {
  background-color: #f8f9fa;
}

.super-admin-table tr:last-child td {
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/components/UserManagement.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".super-admin-management {\n  padding: 20px;\n}\n\n.super-admin-management h2 {\n  color: #65ccb7;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 1.8em;\n}\n\n.section-icon {\n  font-size: 1.4em;\n}\n\n.modal-icon {\n  font-size: 1.2em;\n  margin-right: 8px;\n}\n\n.super-admin-status-approved {\n  background-color: #65ccb7;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 0.9em;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: fit-content;\n  font-weight: 500;\n}\n\n.super-admin-edit-btn,\n.super-admin-edit-credentials-btn,\n.super-admin-delete-btn {\n  padding: 8px 16px;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n}\n\n.super-admin-edit-btn {\n  background-color: #65ccb7;\n}\n\n.super-admin-edit-credentials-btn {\n  background-color: #4a90e2;\n}\n\n.super-admin-delete-btn {\n  background-color: #e74c3c;\n}\n\n.super-admin-edit-btn:hover,\n.super-admin-edit-credentials-btn:hover,\n.super-admin-delete-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.super-admin-edit-btn:hover {\n  background-color: #55bb9f;\n}\n\n.super-admin-edit-credentials-btn:hover {\n  background-color: #357abd;\n}\n\n.super-admin-delete-btn:hover {\n  background-color: #c0392b;\n}\n\n.super-admin-permissions {\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.super-admin-permissions-modal {\n  margin-top: 20px;\n  padding: 24px;\n  background: #f8f9fa;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.super-admin-permissions-modal h3 {\n  color: #333;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  font-size: 1.4em;\n}\n\n.super-admin-permissions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 15px;\n  margin-top: 15px;\n}\n\n.super-admin-permission-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  background: white;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: 1px solid #eee;\n}\n\n.super-admin-permission-item:hover {\n  background: #f5f5f5;\n  transform: translateY(-1px);\n}\n\n.super-admin-pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  margin-top: 30px;\n  list-style: none;\n  padding: 0;\n}\n\n.super-admin-pagination-link {\n  padding: 10px 16px;\n  border: 1px solid #65ccb7;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #65ccb7;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.super-admin-pagination-link:hover {\n  background-color: #f5f5f5;\n}\n\n.super-admin-pagination-active {\n  background-color: #65ccb7;\n  color: white;\n}\n\n.super-admin-pagination-disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.super-admin-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.super-admin-edit-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 2px solid #eee;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n\n.super-admin-edit-input:focus {\n  outline: none;\n  border-color: #65ccb7;\n  box-shadow: 0 0 0 3px rgba(101, 204, 183, 0.1);\n}\n\n.super-admin-table-container {\n  overflow-x: auto;\n  height: 54vh;\n  overflow-y: scroll;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.super-admin-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 0;\n}\n\n.super-admin-table th,\n.super-admin-table td {\n  padding: 16px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.super-admin-table th {\n  background-color: #f8f9fa;\n  color: #333;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.super-admin-table tr:hover {\n  background-color: #f8f9fa;\n}\n\n.super-admin-table tr:last-child td {\n  border-bottom: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
